export default {"src":"/_next/static/media/peep.220551ef.svg","height":1500,"width":1500};